import React from "react";
import Marquee from "react-fast-marquee";

const ITEMS = [
    "FUGAS DIÁRIAS",
    "CARROS CUSTOM",
    "RP SÉRIO",
    "PERSEGUIÇÕES",
    "ECONOMIA REAL",
    "MISSÕES",
    "DRIFT",
    "CREW WAR",
];

export default function Ribbon() {
    return (
        <div
            data-testid="marquee-ribbon"
            className="marquee-strip py-4 -mt-1 relative z-20"
        >
            <Marquee speed={70} gradient={false} pauseOnHover={false}>
                {[...ITEMS, ...ITEMS, ...ITEMS].map((t, i) => (
                    <span
                        key={i}
                        className="font-heading text-3xl md:text-5xl uppercase mx-8 inline-flex items-center gap-8"
                    >
                        <span
                            className={
                                i % 2 === 0
                                    ? "text-neon-yellow"
                                    : "text-stroke-yellow"
                            }
                        >
                            {t}
                        </span>
                        <span className="text-neon-yellow text-2xl">★</span>
                    </span>
                ))}
            </Marquee>
        </div>
    );
}
